import { render } from "./SuperTokensLogin.vue?vue&type=template&id=5fbd92bd&scoped=true&lang=pug"
import script from "./SuperTokensLogin.vue?vue&type=script&lang=js"
export * from "./SuperTokensLogin.vue?vue&type=script&lang=js"

import "./SuperTokensLogin.vue?vue&type=style&index=0&id=5fbd92bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbd92bd"]])

export default __exports__